import React, { useEffect, useContext, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import API from "../pages/Services/Baseservice";
import { LanguageContext } from "../pages/languagecontext";
import FlagImage from "../assets/img/blog-images/flag.png";
import UserIcon from "../assets/img/blog-images/user.svg";
import CalendarIcon from "../assets/img/blog-images/.svg";
import CommentIcon from "../assets/img/blog-images/-1.svg";
import Popular1 from "../assets/img/blog-images/popular1.png";
import CalenderImage from "../assets/img/blog-images/calender.png";
import SEO from "./SEO";
const Blog = () => {
  const navigate = useNavigate();
  const { selectedLanguage } = useContext(LanguageContext);
  const [expandedStates, setExpandedStates] = useState({});

  const [blogslist, setBlogsList] = useState([]);
  const [blogsearch, setBlogSearch] = useState("");
  const [currentpage, setCurrentPage] = useState(1);
  const [totalrecords, setTotalRecords] = useState([]);
  const [totalpages, setTotalPages] = useState(1);
  const [totalcountpagination, setTotalCountPagination] = useState("");
  const [popularPosts, setPopularPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState("");
  const [specialbloglist, setSpecialBloglist] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [leavecomments, setLeaveComments] = useState("");
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [tagslist, setTagsList] = useState([]);
  const [showall, setShowAll] = useState(false);
  const [blogDetails, setBlogDetails] = useState(null);
  const contentRefs = useRef([]);
  const commentsRef = useRef(null);
  const [showButtons, setShowButtons] = useState({});

  const createSlug = (text) => {
    return text
      ?.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setBlogSearch(value);
    setCurrentPage(1);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedLanguage.id]);

  const cleanHTML = (html = "") =>
    html.replace(/(width|height)="[^"]*"/gi, "").replace(/style="[^"]*"/gi, "");

  useEffect(() => {
    if (!blogsearch || blogsearch.trim() === "") {
      blogList();
    } else {
      blogSearch();
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [blogsearch, currentpage, selectedTag, selectedLanguage.id]);
  const imageRef = useRef(null);
  const sidebarRef = useRef(null);
  const sidebarWrapperRef = useRef(null);
  const contentRef = useRef(null);
  const parentRef = useRef(null);
  const sidebarInitialTopRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sidebarRef.current || !contentRef.current) return;

      const sidebar = sidebarRef.current;
      const content = contentRef.current;

      const header = document.querySelector("header");
      const headerHeight = header ? header.offsetHeight : 120;

      if (sidebarInitialTopRef.current === null) {
        sidebarInitialTopRef.current =
          sidebar.getBoundingClientRect().top + window.scrollY;
      }

      const sidebarInitialTop = sidebarInitialTopRef.current;
      const sidebarHeight = sidebar.offsetHeight;

      const contentTop = content.offsetTop;
      const contentHeight = content.offsetHeight;

      const stickStart = sidebarInitialTop - headerHeight;
      const stickEnd =
        contentTop + contentHeight - sidebarHeight - headerHeight + 400;

      if (window.scrollY < stickStart) {
        sidebar.style.position = "static";
        sidebar.style.top = "auto";
        sidebar.style.width = "auto";
      } else if (window.scrollY >= stickStart && window.scrollY <= stickEnd) {
        sidebar.style.position = "fixed";
        sidebar.style.top = headerHeight + "px";
        sidebar.style.width =
          sidebar.parentElement.getBoundingClientRect().width + "px";
      } else {
        sidebar.style.position = "absolute";
        sidebar.style.top = contentHeight - sidebarHeight + "px";
        sidebar.style.width =
          sidebar.parentElement.getBoundingClientRect().width + "px";
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  useEffect(() => {
    const buttonsVisibility = {};
    blogslist.forEach((_, index) => {
      const element = contentRefs.current[index];
      if (element) {
        const lineHeight = parseFloat(
          window.getComputedStyle(element).lineHeight,
        );
        const maxVisibleHeight = lineHeight * 5;
        if (element.scrollHeight > maxVisibleHeight) {
          buttonsVisibility[index] = true;
        }
      }
    });
    setShowButtons(buttonsVisibility);
  }, [blogslist]);
  useEffect(() => {
    if (selectedLanguage?.id) {
      fetchPopularPosts();
      fetchTags();
    }
  }, [selectedLanguage]);

  const blogList = () => {
    setLoading(true);
    const req = {
      search: "",
      rowsPerPage: 3,
      page: currentpage,
      blog_tag_id: selectedTag ? [selectedTag] : [],
      language_id: selectedLanguage.id,
    };

    API.post("webBlogs_list/webCondition", req)
      .then((response) => {
        if (response.data?.success === true) {
          const data = response.data.data;
          setBlogsList(data || []);
          const totalCount = response.data.totalCount || 0;
          setTotalCountPagination(totalCount);
          const totalPages = Math.ceil(totalCount / 3);
          setTotalPages(totalPages);
          setTotalRecords([...Array(totalPages + 1).keys()].slice(1));
        } else {
          console.warn("API returned success = false");
        }
      })
      .catch((error) => {
        console.error("API error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchPopularPosts = () => {
    const req = {
      page: 1,
      rowsPerPage: 3,
      language_id: selectedLanguage.id,
    };
    API.post("webblog_list/webCondition", req).then((response) => {
      if (response.data.success === true) {
        setPopularPosts(response.data.data.data || []);
      }
    });
  };

  const fetchTags = () => {
    const req = {
      search: "",
      status: "active",
      language_id: selectedLanguage.id,
    };
    API.post("webblogtag_list/webCondition", req).then((response) => {
      if (response.data.data.success === true) {
        setTagsList(response.data.data.data || []);
      }
    });
  };

  const blogSearch = () => {
    const req = {
      search: blogsearch,
      rowsPerPage: 3,
      page: currentpage,
      blog_tag_id: selectedTag ? [selectedTag] : [],
      language_id: selectedLanguage.id,
    };
    API.post("webBlogs_list/webCondition", req)
      .then((response) => {
        if (response.data?.success === true) {
          const data = response.data;
          setBlogsList(data.data || []);
          const totalCount = data.totalCount || 0;
          setTotalCountPagination(totalCount);
          const totalPages = Math.ceil(totalCount / 3);
          setTotalPages(totalPages);
          setTotalRecords([...Array(totalPages + 1).keys()].slice(1));
        } else {
          setBlogsList([]);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setBlogsList([]);
      });
  };

  // const handleBlogClick = (item) => {
  //   navigate(`/blog-details/${item.blog_id}`, {
  //     state: { item, specialbloglist },
  //   });
  // };
  const handleBlogClick = (item) => {
    const slug = createSlug(item.heading);
    navigate(`/${slug}`, {
      state: { id: item.blog_id },
    });
  };
  const handleCommentClick = (item) => {
    setSelectedBlog(item.blog_id);
    setBlogDetails(item);
    setTimeout(() => {
      if (commentsRef.current) {
        const element = commentsRef.current;
        const yOffset = -100;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 100);
  };

  const handleAddComment = (e, item) => {
    e.preventDefault();
    const req = {
      language_id: selectedLanguage.id || 1,
      blog_id: item.blog_id,
      user_name: name,
      email: email,
      comments: leavecomments,
      createdBy: name,
      updatedBy: name,
    };

    API.post("webAdd_blogcomments/add1", req)
      .then((response) => {
        if (response.data.success === true) {
          setName("");
          setEmail("");
          setLeaveComments("");
          blogList();
          setSelectedBlog(null);
        } else {
          console.error("Failed to add comment:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error posting comment:", error);
      });
  };

  const visibleTags = showall ? tagslist : tagslist.slice(0, 8);

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <div style={{ overflowX: "hidden" }}>
       <SEO
        title="Canada visitor visa consultant| Immigration consultant Canada"
        description="Expert insights from ASRA Immigration on visas and pathways to Canada. Trusted Canada visitor visa consultant guidance for smooth, stress-free applications."
        canonical="https://asraimmigration.ca/blog"
      />
      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <div className="container px-3">
            <section className="faq-hero container p-4 p-lg-5 rounded-5">
              <h1> {selectedLanguage.id === 1 ? "Blog" : "Blogue"}</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <span
                      onClick={handleHomeClick}
                      style={{ cursor: "pointer" }}
                    >
                      {selectedLanguage.id === 1 ? "Home" : "Accueil"}
                    </span>
                  </li>
                  <li className="breadcrumb-item active">
                    {" "}
                    {selectedLanguage.id === 1 ? "Blog" : "Blogue"}{" "}
                  </li>
                </ol>
              </nav>
            </section>

            <div className="blog-wrapper mt-lg-5 pt-lg-5">
              <div className="mobile-search-box d-lg-none mt-3 mb-4">
                <div className="search-card">
                  <h4 className="search-title">
                    {selectedLanguage.id === 1
                      ? "Search Here"
                      : "Rechercher ici"}
                  </h4>
                  <hr className="search-divider" />
                  <div className="search-wrapper">
                    <input
                      type="text"
                      placeholder={
                        selectedLanguage.id === 1 ? "Search.." : "Rechercher.."
                      }
                      className="search-input"
                      value={blogsearch}
                      onChange={handleSearchChange}
                    />
                    <i className="bi bi-search search-icon"></i>
                  </div>
                </div>
              </div>

              <main className="blogmargintop mb--md-5">
                <div
                  className="row g-4 align-items-start"
                  ref={parentRef}
                  style={{ position: "relative" }}
                >
                  <section className="col-lg-7" ref={contentRef}>
                    {blogslist.length > 0 ? (
                      blogslist.map((item, index) => (
                        <article className="post mb-5" key={index}>
                          <img
                            src={item.blog_image || FlagImage}
                            alt="Blog"
                            className="faqimage mb-3 w-100 rounded-5"
                          />
                          <div className="d-flex gap-4 align-items-center mb-2 flex-wrap">
                            <div className="d-flex align-items-center gap-2">
                              <img
                                src={UserIcon}
                                className="usericon"
                                alt="Author"
                              />
                              <p className="mb-0 byadmin">
                                {item.author_name || "Author Name"}
                              </p>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <img
                                src={CalendarIcon}
                                className="calendericon"
                                alt="Date"
                              />
                              <p className="mb-0 byadmin">
                                {item.blog_date || "June 10, 2025"}
                              </p>
                            </div>
                            <div
                              className="d-flex align-items-center gap-2"
                              onClick={() => handleCommentClick(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={CommentIcon}
                                className="commenticon"
                                alt="Comments"
                              />
                              <p className="mb-0 byadmin">
                                {selectedLanguage.id === 1
                                  ? "Comments"
                                  : "Commentaires"}{" "}
                                ({item.comments?.length || 0})
                              </p>
                            </div>
                          </div>
                          <h3
                            className="wonderof fw-semibold"
                            dangerouslySetInnerHTML={{ __html: item.heading }}
                          ></h3>
                          <div
                            ref={(el) => (contentRefs.current[index] = el)}
                            className="aliquam mt-3"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: expandedStates[index]
                                ? "unset"
                                : 5,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            dangerouslySetInnerHTML={{
                              __html:
                                cleanHTML(item.description) ||
                                "Aliquam eros justo, posuere loborti viverra laoreet matti ullamcorper posuere viverra...",
                            }}
                          />
                          {showButtons[index] ? (
                            <button
                              className="btn btn-light rounded-btn leanmore mt-3"
                              onClick={() => handleBlogClick(item)}
                            >
                              {selectedLanguage.id === 1
                                ? "Learn More"
                                : "En savoir plus"}
                              <i className="bi bi-arrow-right ms-2"></i>
                            </button>
                          ) : (
                            <div className="mb-5"></div>
                          )}

                          {selectedBlog === item.blog_id && (
                            <div
                              className="container col-lg-12 comments-section mb-3"
                              style={{ minHeight: "400px", marginTop: "50px" }}
                              ref={commentsRef}
                            >
                              <div className="shadow-sm p-3 bg-white rounded col-12">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h2 className="leaveacooment">
                                    {selectedLanguage.id === 1
                                      ? "Leave a Comment"
                                      : "Laissez un commentaire"}
                                  </h2>

                                  <button
                                    className="btn btnredcolour btn-sm"
                                    onClick={() => setSelectedBlog(null)}
                                  >
                                    {selectedLanguage.id === 1
                                      ? "Close"
                                      : "Fermer"}
                                  </button>
                                </div>

                                <div className="shadow-sm p-3 steelblue rounded col-lg-12">
                                  <div className="row mb-3 mt-3">
                                    <div className="col-12 col-md-6">
                                      <label className="labelnamesblog">
                                        {selectedLanguage.id === 1
                                          ? "Name"
                                          : "Nom"}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control typeyourtext"
                                        placeholder={
                                          selectedLanguage.id === 1
                                            ? "Type your Name"
                                            : "Tapez votre nom"
                                        }
                                        value={name}
                                        onChange={(e) =>
                                          setName(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="col-12 col-md-6">
                                      <label className="labelnamesblog">
                                        {selectedLanguage.id === 1
                                          ? "Email Address"
                                          : "Adresse e-mail"}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control typeyourtext"
                                        placeholder={
                                          selectedLanguage.id === 1
                                            ? "Type Your Email Address"
                                            : "Tapez votre adresse e-mail"
                                        }
                                        value={email}
                                        onChange={(e) =>
                                          setEmail(e.target.value)
                                        }
                                        rows={2}
                                      />
                                    </div>
                                  </div>

                                  <div className="col mt-3">
                                    <label className="labelnamesblog">
                                      {selectedLanguage.id === 1
                                        ? "Leave a Comment"
                                        : "Laissez un commentaire"}
                                    </label>
                                    <textarea
                                      className="form-control typeyourtext"
                                      placeholder={
                                        selectedLanguage.id === 1
                                          ? "Type Your comments here"
                                          : "Tapez vos commentaires ici"
                                      }
                                      value={leavecomments}
                                      onChange={(e) =>
                                        setLeaveComments(e.target.value)
                                      }
                                      rows={5}
                                    />
                                  </div>

                                  <div className="d-flex justify-content-end">
                                    <div className="steelblue rounded d-flex gap-2 mt-3">
                                      <button
                                        className="btn prevredcolour"
                                        onClick={(e) =>
                                          handleAddComment(e, item)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {selectedLanguage.id === 1
                                          ? "Post"
                                          : "Publication"}{" "}
                                        <i className="bi bi-arrow-right arrowbold"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="shadow-sm p-4 rounded commentslist mt-3"
                                  style={{
                                    maxHeight: "400px",
                                    overflowY: "auto",
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  <h5 className="mb-3">
                                    {" "}
                                    {selectedLanguage.id === 1
                                      ? "Comments"
                                      : "Commentaires"}{" "}
                                    ({item.comments?.length || 0})
                                  </h5>
                                  {item.comments && item.comments.length > 0 ? (
                                    item.comments.map((item, index) => (
                                      <div
                                        key={index}
                                        className="mb-3 p-3 rounded"
                                        style={{
                                          backgroundColor: "#ffffff",
                                          boxShadow:
                                            "0 2px 5px rgba(0,0,0,0.1)",
                                        }}
                                      >
                                        <p
                                          className="commentsp mb-1"
                                          style={{
                                            fontWeight: "600",
                                            color: "#343a40",
                                          }}
                                        >
                                          {item.user_name}
                                        </p>
                                        <p
                                          className="text-muted mb-0"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {item.comments}
                                        </p>
                                      </div>
                                    ))
                                  ) : (
                                    <p className="text-secondary">
                                      {selectedLanguage.id === 1
                                        ? "No comments yet"
                                        : "Aucun commentaire pour le moment"}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </article>
                      ))
                    ) : (
                      <div className="text-center py-5">
                        <p className="text-danger">
                          {selectedLanguage.id === 1
                            ? "No blogs found"
                            : "Aucun blog trouvé"}
                        </p>
                      </div>
                    )}
                  </section>

                  <aside className="col-lg-5 sidebar-content">
                    <div className="sidebar-parent" ref={sidebarWrapperRef}>
                      <div ref={sidebarRef} className="sidebar">
                        <div ref={imageRef} className="sidebar-sticky">
                          <div className="search-card">
                            <h4 className="search-title">
                              {selectedLanguage.id === 1
                                ? "Search Here"
                                : "Rechercher ici"}
                            </h4>
                            <hr className="search-divider" />
                            <div className="search-wrapper">
                              <input
                                type="text"
                                placeholder={
                                  selectedLanguage.id === 1
                                    ? "Search.."
                                    : "Rechercher.."
                                }
                                className="search-input"
                                value={blogsearch}
                                onChange={handleSearchChange}
                              />
                              <i className="bi bi-search search-icon"></i>
                            </div>
                          </div>
                          <div className="search-card mb-4 bg-white">
                            <h4 className="h4textcontent">
                              {selectedLanguage.id === 1
                                ? "Popular Posts"
                                : "Articles populaires"}
                            </h4>
                            <hr className="expressdividers" />
                            {popularPosts.length > 0 ? (
                              popularPosts.map((item, index) => (
                                <div
                                  className="d-flex align-items-start mb-3"
                                  key={index}
                                >
                                  <img
                                    src={item.blog_image || Popular1}
                                    className="menicons"
                                    alt="Blog thumbnail"
                                  />
                                  <div className="ms-3">
                                    <div className="d-flex align-items-center mb-1">
                                      <img
                                        src={CalenderImage}
                                        className="calenderimage me-2"
                                        alt="date"
                                      />
                                      <p className="mb-0 small">
                                        {item.blog_date || "April 2, 2025"}
                                      </p>
                                    </div>
                                    <p
                                      className="findyouradventurelive mb-0"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleBlogClick(item)}
                                    >
                                      {item.heading || "Popular blog title"}
                                    </p>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-muted small">
                                {selectedLanguage.id === 1
                                  ? "No popular posts"
                                  : "Aucun article populaire"}
                              </p>
                            )}
                          </div>

                          <div className="search-card mb-4 bg-white">
                            <h4 className="h4textcontent">
                              {selectedLanguage.id === 1
                                ? "Popular Tags"
                                : "Étiquettes populaires"}
                            </h4>
                            <hr className="expressdividers" />
                            <div className="mt-2">
                              {visibleTags.map((tag, index) => (
                                <button
                                  key={index}
                                  className={`btn rounded-btn me-2 mt-2 ${selectedTag === tag.blog_tag_id ? "btn-dark" : "btn-light"}`}
                                  onClick={() =>
                                    setSelectedTag(
                                      selectedTag === tag.blog_tag_id
                                        ? ""
                                        : tag.blog_tag_id,
                                    )
                                  }
                                >
                                  {tag.blogtag}
                                </button>
                              ))}
                              {tagslist.length > 8 && (
                                <div className="mt-2">
                                  <button
                                    className="btn btn-light rounded-btn me-2"
                                    onClick={() => setShowAll(!showall)}
                                  >
                                    {showall
                                      ? selectedLanguage.id === 1
                                        ? "Show Less"
                                        : "Montrer moins"
                                      : selectedLanguage.id === 1
                                        ? "More"
                                        : "Plus"}
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </aside>
                </div>
              </main>

              {totalrecords.length > 1 && (
                <div className="pagination-wrapper mb-md-5 pb-5">
                  <p className="entries-info">
                    {selectedLanguage.id === 1 ? "Showing" : "Affichage"}{" "}
                    {(currentpage - 1) * 3 + 1} to{" "}
                    {Math.min(currentpage * 3, totalcountpagination)} of{" "}
                    {totalcountpagination}{" "}
                    {selectedLanguage.id === 1 ? "entries" : "entrées"}
                  </p>

                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() =>
                          currentpage > 1 && setCurrentPage(currentpage - 1)
                        }
                        disabled={currentpage === 1}
                      >
                        <i className="bi bi-chevron-double-left"></i>
                      </button>
                    </li>

                    <li
                      className={`page-item ${currentpage === 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </button>
                    </li>

                    {currentpage > 3 && totalpages > 3 && (
                      <li className="page-item">
                        <span className="page-link">...</span>
                      </li>
                    )}

                    {Array.from({ length: totalpages }, (_, i) => i + 1)
                      .filter((page) => {
                        if (page === 1 || page === totalpages) return false;
                        if (totalpages <= 5) return true;
                        return Math.abs(page - currentpage) <= 1;
                      })
                      .map((page) => (
                        <li
                          key={page}
                          className={`page-item ${currentpage === page ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                    {currentpage < totalpages - 2 && totalpages > 3 && (
                      <li className="page-item">
                        <span className="page-link">...</span>
                      </li>
                    )}

                    {totalpages > 1 && (
                      <li
                        className={`page-item ${currentpage === totalpages ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(totalpages)}
                        >
                          {totalpages}
                        </button>
                      </li>
                    )}

                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() =>
                          currentpage < totalpages &&
                          setCurrentPage(currentpage + 1)
                        }
                        disabled={currentpage === totalpages}
                      >
                        <i className="bi bi-chevron-double-right"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div class="btn-pair1 mb-3  ">
              <a class="nav-link" onClick={() => navigate("/news")}>
                <button class="btn btn-danger d-flex align-items-center justify-content-center">
                  <p class="p-0 m-0">
                    {selectedLanguage.id === 1
                      ? "Latest News"
                      : "Dernières nouvelles"}
                  </p>
                  <i class="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                </button>
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Blog;
